$(document).bind('_js_ready', function () {
    const $inputs = $('input[type="password"]');
    $inputs.each(function () {
        let $input = $(this);
        let $viewButton = $input.parent().find(".view_password");
        if ($viewButton.length) {
            $viewButton.on('click', function () {
                let title;
                if ($input.attr('type') === 'password') {
                    $input.attr('type', 'text');
                    title = 'Dissimuler le mot de passe';
                } else {
                    $input.attr('type', 'password');
                    title = 'Révéler le mot de passe';
                }
                $(this).text(title).attr('title', title);
                $input.focus();
            });
        }
    });
});
